import { PAGES } from "@dune/types";
import { GFAFullDetails } from "@dune/types";
import { Button, Card, H2, H3, Separator } from "@dune/ui";
import { getMOAName, getRealEstateName } from "@dune/utils";
import { FormProvider } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { GFADocumentsTable } from "../../../../component/gfa/GFADocumentsTable";
import GFAExperiencesContainer from "../../../../component/gfa/GFAExperiencesContainer";
import GFAShareholdersContainer from "../../../../component/gfa/GFAShareholdersContainer";
import { useGFAShareholdersAndExperiencesForm } from "../../../../component/gfa/useGFAShareholdersAndExperiencesForm";

interface GFAOperatorTabProps {
	gfa: GFAFullDetails;
}

export const GFAOperatorTab = ({ gfa }: GFAOperatorTabProps) => {
	const navigate = useNavigate();
	const { form: shareholdersAndExperiencesForm } =
		useGFAShareholdersAndExperiencesForm(gfa ?? null);

	if (!gfa) return <div>Aucune projet GFA trouvé</div>;
	const moaNames = getMOAName(gfa.constructionSiteClientDetails);
	return (
		<div>
			<div className="flex justify-between items-center">
				<H2>Opérateur</H2>
				<Button
					type="button"
					onClick={() =>
						navigate(PAGES.GFA.edit.withParams(gfa.id.toString(), 4))
					}
				>
					Modifier l'opération
				</Button>
			</div>
			<FormProvider {...shareholdersAndExperiencesForm}>
				<div className="flex flex-row gap-4">
					<div className="flex flex-row flex-1 gap-4">
						<Card className="p-4 flex-1">
							<div className="flex items-center gap-2 mb-2">
								<span className="text-sm font-medium text-gray-700">MOA</span>
							</div>
							<div className="flex flex-col text-lg font-semibold gap-2">
								{Array.isArray(moaNames) ? (
									<>
										{moaNames.map((client: string, index: number) => {
											return (
												<>
													<span key={client}>{client}</span>
													{index < moaNames.length - 1 && (
														<span className="text-xs text-gray-500">-</span>
													)}
												</>
											);
										})}
									</>
								) : (
									moaNames
								)}
							</div>
						</Card>
						<Card className="p-4 flex-1">
							<div className="flex items-center gap-2 mb-2">
								<span className="text-sm font-medium text-gray-700">
									{"Promoteur"}
								</span>
							</div>
							<div className="flex flex-col">
								<span className="text-lg font-semibold">
									{getRealEstateName(gfa)}
								</span>
								<span className="text-xs text-gray-500">-</span>
							</div>
						</Card>
					</div>
					<div className="flex-1">
						<GFADocumentsTable
							gfaConstructionSite={gfa}
							section="OPERATOR_FILES"
							isForm={false}
						/>
					</div>
				</div>
			</FormProvider>
			<Separator className="my-8" />

			<FormProvider {...shareholdersAndExperiencesForm}>
				<div className="flex flex-row gap-4">
					<div className="flex-1">
						<div className="flex flex-row justify-between items-center">
							<H3 className="mb-0">ACTIONNAIRES</H3>
						</div>

						<GFAShareholdersContainer isForm={false} />
					</div>
					<div className="flex-1">
						<GFADocumentsTable
							gfaConstructionSite={gfa}
							section="SHAREHOLDERS_FILES"
							isForm={false}
						/>
					</div>
				</div>
			</FormProvider>

			<Separator className="my-8" />

			<FormProvider {...shareholdersAndExperiencesForm}>
				<div className="flex flex-row gap-4">
					<div className="flex-1">
						<H3>OPÉRATIONS EN COURS OU LIVRÉES DANS LES 36 DERNIERS MOIS</H3>
						<GFAExperiencesContainer isForm={false} />
					</div>
				</div>
			</FormProvider>
		</div>
	);
};
